import Vue from 'vue';
import constants from '~~/common/vue/plugins/constants';

Vue.use(constants);
